import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Button, ButtonProps} from '_uiComponents'
import {useModal} from '_context'
import {Box, BoxProps, HStack, StackProps, Text, TextProps, useMultiStyleConfig} from '@chakra-ui/react'
import {useMinicart} from '_customHooks'

interface WishlistSizeModalProps {
    shouldOpenMiniCartOnClose: boolean
}

/**
 * @name WishlistSizeModal
 *
 * @component
 *
 * @description
 * Contains some indications about the demand of size selection
 * when adding all products of a wishlist to cart.
 *
 * @param {WishlistSizeModalProps} props - Properties object.
 * @param {boolean} props.shouldOpenMinicartOnClose - Indicates if on close it must open the minicart drawer.
 *
 * @returns {React.FC<WishlistSizeModalProps>} - Rendered `WishlistSizeModal` component.
 */
const WishlistSizeModal: React.FC<WishlistSizeModalProps> = ({shouldOpenMiniCartOnClose}) => {
    const styles = useMultiStyleConfig('WishlistSizeModal') as Record<string, BoxProps & StackProps & TextProps>
    const {closeModal} = useModal()
    const {previewMinicart} = useMinicart()

    const handleClose = () => {
        closeModal()

        if (shouldOpenMiniCartOnClose) {
            previewMinicart()
        }
    }

    return (
        <Box data-testid="wishlist-size-modal">
            <Box {...styles.body}>
                <Text {...styles.title} as="h2">
                    <FormattedMessage id="label.requestsize.title" defaultMessage="Select your size" />
                </Text>
                <Text {...styles.description}>
                    <FormattedMessage id="label.popup.text" defaultMessage="To add the Wishlist to your cart, select the size of all products" />
                </Text>
            </Box>
            <HStack {...styles.footer}>
                <Button {...(styles.closeButton as ButtonProps)} onClick={handleClose} size="md">
                    <FormattedMessage id="alt.link.close" defaultMessage="Close" />
                </Button>
            </HStack>
        </Box>
    )
}

export {WishlistSizeModal}
